import React from 'react';
import useDesignerStore from './designerStore';
import { prospectiveCaptureInputs } from './prospectiveCaptureBinding';

export default function NewCapturePhotoInput() {
  const state=useDesignerStore();
  if(!state.newCaptureInputDraft||state.cardId)return null;
  const {options,invalid}=prospectiveCaptureInputs(state);
  if(!options.length&&!invalid)return null;
  const value=state.captureInputSelection ?? (options.length===1?options[0].key:'');
  return <div className="p-2">
    <label htmlFor="new-capture-photo-input">Captured photo input</label>
    <select id="new-capture-photo-input" value={value} onChange={e=>state.setCaptureInputSelection(e.target.value)}>
      <option value="">Choose frame</option>
      {options.map(o=><option key={o.key} value={o.key}>{o.side} — frame {o.elementId}</option>)}
    </select>
    {(invalid||!value)&&<div role="alert">Choose the intended input; frames are never selected by their order.</div>}
    <p>New Landing Page photographs fill this fixed frame proportionally. Artwork stays unchanged.</p>
  </div>;
}
